export default {"src":"/_next/static/media/lk-eye.414eca0f.svg","height":32,"width":32};